export enum LanguageEnum {
  zh_CN = 'zh_CN',

  en_US = 'en_US',
  ru_RU = 'ru_RU',
  uz_UZ = 'uz_UZ',
  ja_JP = 'ja_JP',
  ko_KR = 'ko_KR',
  zh_TW = 'zh_TW',
  fr_FR = 'fr_FR',
  de_DE = 'de_DE',
  es_ES = 'es_ES',
  pt_PT = 'pt_PT',
  it_IT = 'it_IT',
  tr_TR = 'tr_TR',

}
